/**
 * Created by anatolij on 22.10.2026
 */

const RoyalLeagueTutorial = function () {
    return new TutorialScenario(RoyalLeagueTutorial.NAME, {
        listSteps: RoyalLeagueTutorial.listSteps,
        isAvailable: function () {
            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_ROYAL_LEAGUE);

            return mission && !mission.needShowStartWindow && !cleverapps.forces.isShown(Forces.ROYAL_LEAGUE);
        }
    });
};

RoyalLeagueTutorial.listSteps = function () {
    const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_ROYAL_LEAGUE);

    return [
        RoyalLeagueTutorial.createCloseStartWindowStep(),
        RoyalLeagueTutorial.createPauseStep(),
        RoyalLeagueTutorial.createIconStep(mission),
        RoyalLeagueTutorial.createHelpStep()
    ];
};

RoyalLeagueTutorial.createCloseStartWindowStep = function () {
    return new TutorialStep({
        onStart: function () {
            const window = cleverapps.focusManager.currentWindow();
            if (!window) {
                this.finish();
                return;
            }

            cleverapps.focusManager.setEventNodes([window]);

            cleverapps.tutorial.on("window_closed", (options) => {
                if (options.windowName === window.name) {
                    this.finish();
                }
            }, this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

RoyalLeagueTutorial.createPauseStep = function () {
    return new TutorialStep({
        onStart: function () {
            cleverapps.timeouts.setTimeout(() => {
                this.finish();
            }, 500);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

RoyalLeagueTutorial.createIconStep = function (mission) {
    return new TutorialStep({
        onStart: function () {
            const icon = cleverapps.sideBar.findMissionIcon(mission.type);
            const target = cleverapps.aims.getTarget(`mission${mission.type}`, { noDefault: true });

            cleverapps.focusManager.showControlsWhileFocused(icon.control, true);
            this.force = cleverapps.forces.create(target, { text: "RoyalLeague.Force.Icon" });

            if (!this.force) {
                this.finish();
                return;
            }

            cleverapps.tutorial.on("window_shown", (options) => {
                if (options.windowName === "RoyalLeagueWindow") {
                    this.finish();
                }
            }, this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

RoyalLeagueTutorial.createHelpStep = function () {
    const createForce = function () {
        const window = cleverapps.focusManager.currentWindow();
        const help = ComponentUtils.findChildByName(window, "help");

        return cleverapps.forces.create(help, Forces.ROYAL_LEAGUE, {
            importantNodes: [help]
        });
    };

    return new TutorialStep({
        onStart: function () {
            this.force = createForce();

            if (!this.force) {
                this.finish();
                return;
            }

            cleverapps.tutorial.on("onResize", () => {
                this.force && this.force.close();
                this.force = createForce();
            }, this);

            cleverapps.tutorial.on("window_shown", (options) => {
                if (options.windowName === "RoyalLeagueRulesWindow") {
                    this.finish();
                }
            }, this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
            this.force = undefined;
        }
    });
};

RoyalLeagueTutorial.NAME = "royal_league_tutorial";
